import { createFileRoute, redirect } from '@tanstack/react-router'
import { getSession, defaultLocation } from '../lib/session'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const session = getSession()
    if (!session) throw redirect({ to: '/auth/login', replace: true })
    const { clusterId, scopeId } = defaultLocation(session)
    throw redirect({
      to: '/$clusterId/$scopeId/home',
      params: { clusterId, scopeId },
      replace: true,
    })
  },
})
